import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Navbar.css";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [transparent, setTransparent] = useState(false);

  const location = useLocation();
  const isHome = location.pathname === "/";
  const isNuestrasRedes = location.pathname === "/nuestras-redes";
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const toggleRef = useRef(null);
  const menuRef = useRef(null);

  const handleHomeClick = () => {
    setMenuOpen(false);
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setTransparent(window.scrollY > 50);
    };
    if (isHome) {
      window.addEventListener("scroll", handleScroll);
    }
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  // Trampa de foco + cierre con Escape para el menú móvil
  useEffect(() => {
    if (!menuOpen) return;

    const menuEl = menuRef.current;
    if (!menuEl) return;

    const focusableEls = menuEl.querySelectorAll('a[href], button:not([disabled])');
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setMenuOpen(false);
        toggleRef.current?.focus();
        return;
      }
      if (e.key === 'Tab' && focusableEls.length > 0) {
        if (e.shiftKey && document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        } else if (!e.shiftKey && document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [menuOpen]);


  const navClass = isHome
    ? transparent
      ? "navbar navbar-transparent"
      : "navbar navbar-home"
    : "navbar navbar-black";

  return (
    <nav className={navClass}>
      <div className="navbar-inner-container">
        <a href="/" className="logo">
          <img src="/img/simbolo-02.png" alt="Logo SparklingTech" />
        </a>

        <button
          type="button"
          className="menu-toggle"
          ref={toggleRef}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={menuOpen}
        >
          {menuOpen ? "✖" : "☰"}
        </button>

        <ul className={`nav-links ${menuOpen ? "active" : ""}`} ref={menuRef}>
          <li><button onClick={handleHomeClick} className="link-button" aria-current={isHome ? "page" : undefined}>Home</button></li>

          <li className="dropdown">
            <Link to="/about" onClick={() => setMenuOpen(false)} aria-haspopup="true" aria-current={location.pathname === "/about" ? "page" : undefined}>Conócenos</Link>
            <ul className="dropdown-menu">
              <li><Link to="/about" onClick={() => setMenuOpen(false)}>¿Quiénes somos?</Link></li>
              <li><Link to="/sparkling-social" onClick={() => setMenuOpen(false)} aria-current={location.pathname === "/sparkling-social" ? "page" : undefined}>Sparkling Social</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="/projects" onClick={() => setMenuOpen(false)} aria-haspopup="true" aria-current={location.pathname === "/projects" ? "page" : undefined}>Proyectos</Link>
            <ul className="dropdown-menu">
              <li><Link to="/projects" onClick={() => setMenuOpen(false)}>Ver todos</Link></li>
              <li><a href="https://patrimoniovivo.sparklingtech.es/" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>Patrimonio Vivo</a></li>
              <li><a href="https://adaia.sparklingtech.es/" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>ADAIA</a></li>
              <li><a href="https://neuroglint.sparklingtech.es/" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>NeuroGlint</a></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="/movespark" onClick={() => setMenuOpen(false)} aria-haspopup="true" aria-current={location.pathname === "/movespark" ? "page" : undefined}>Laboratorios</Link>
            <ul className="dropdown-menu">
              <li><Link to="/movespark" onClick={() => setMenuOpen(false)}>MoveSpark Lab</Link></li>
            </ul>
          </li>

          <li><Link to="/mas-alla-del-id" onClick={() => setMenuOpen(false)} aria-current={location.pathname === "/mas-alla-del-id" ? "page" : undefined}>Más allá del I + D + i</Link></li>
          <li><Link to="/nuestras-redes" onClick={() => setMenuOpen(false)} aria-current={location.pathname === "/nuestras-redes" ? "page" : undefined}>Nuestras Redes</Link></li>
          <li><Link to="/contacto" onClick={() => setMenuOpen(false)} aria-current={location.pathname === "/contacto" ? "page" : undefined}>Contáctanos</Link></li>

          {/* SOLO en /nuestras-redes se muestra el botón de cerrar sesión si está loggeado */}
          {isNuestrasRedes && isAuthenticated && (
            <li>
              <button
                onClick={() => {
                  logout();
                  navigate("/nuestras-redes");
                  setMenuOpen(false);
                }}
                className="link-button"
              >
                Cerrar sesión
              </button>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
